import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { GetNonOverlappingNodeNamesAsync } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/BookOfMindNodeIndex";

export async function GetNonOverlappingReadingListAsync(
    selectedNode: IWorkflowNode,
    currentNodeNames: string[]
) {
    return GetNonOverlappingNodeNamesAsync(
        selectedNode,
        currentNodeNames
    );
}
